import React from 'react';
import PropTypes from 'prop-types';
import BuildChildren from 'utils/BuildChildren';
import Button from 'components/Button';
import classNames from 'classnames';
import classes from './ModalB.module.scss';

const ModalB = ({
  children,
  hideModal,
  containerClass = '',
}) => (
  <div className={classes.wrapper}>
    <div className={classNames(containerClass, classes.container)}>
      <div className={classes.body}>{BuildChildren(children)}</div>
      <div className={classes.footer}>
        <Button subType='ButtonE' title='Close' onClick={hideModal} />
      </div>
    </div>
  </div>
);

ModalB.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  hideModal: PropTypes.func.isRequired,
  containerClass: PropTypes.string,
};

export default ModalB;
